import { render } from "./product.vue?vue&type=template&id=33ea8148"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"
script.render = render

export default script